import SegmentReportPreviewModal from './SegmentReportPreviewModal';

export default SegmentReportPreviewModal;
